import { useTranslation } from 'react-i18next'
import { Button } from '../../../iba-components/Button'
import { Modal } from '../../../iba-components/Modal'
import LoadingMask from '../LoadingMask'
import styles from './index.module.css'

const Footer = ({ onCancel, cancelBtnText, onSubmit, confirmBtnText }) => {
    return (
        <div className={styles.footer}>
            <Button label={cancelBtnText} width="82px" kind="text" onClick={onCancel} isGray />
            <Button label={confirmBtnText} width="68px" kind="text" onClick={onSubmit} />
        </div>
    )
}

const ConfirmModal = (props) => {
    const { t } = useTranslation()

    const {
        visible,
        title = t(`common.confirmModalTitle`),
        content,
        contentTips,
        onCancel,
        onSubmit,
        confirmBtnText = t(`common.yes`),
        cancelBtnText = t(`common.no`),
        isLoading = false
    } = props

    return (
        <Modal
            wrapperClassName={styles.modal}
            visible={visible}
            placement="top"
            width={500}
            onCancel={onCancel}
            title={title}
            footer={
                <Footer
                    onCancel={onCancel}
                    cancelBtnText={cancelBtnText}
                    onSubmit={onSubmit}
                    confirmBtnText={confirmBtnText}
                />
            }
        >
            {props.children}
            <div className="a-fw-500 a-apply-theme-font-default-white">{content}</div>
            {contentTips && <div className="description a-apply-theme-font-default-white">{contentTips}</div>}
            {isLoading ? <LoadingMask /> : ''}
        </Modal>
    )
}

export default ConfirmModal
